import React from 'react';
import Relay from 'react-relay';
import EditSport from './EditSport';
import AddSport from './AddSport';

import Button from '../../components/Button';

class SportPage extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      lang : '',
    }
  }

  componentWillReceiveProps(nextProps){
  }

  onLangClick(){
    const { that, text } = this.props;

    that.setState({
      lang : text,
    });
    let path = '/sports/list';
    that.props.router.push({
      pathname : path,
      state :{
        lang : text,
      }
    });

  }

  _renderLangBtnGroup(){
    return (
      <div>
        {

          this.props.viewer.supportedLanguages.map( (lang, index, arr)=> {

            let color = 'btn-default';
            if( lang == this.state.lang ){
              color = 'btn-danger';
            }

            return  <Button
                      key={index}
                      that={this}
                      text={lang}
                      color={color}
                      onClick={this.onLangClick}
                    />
          })
        }
      </div>
    )
  }

  _renderChildren = () =>
    React.Children.map(this.props.children, child =>
      React.cloneElement(child, {
        ...this.props,
      })
    )

  render() {
    return (
      <div className="container">
        <div style={{marginTop:20}}>
            {this._renderLangBtnGroup()}
        </div>
        {this._renderChildren()}
      </div>
    );

  }
}


SportPage.propTypes = ({
  children: React.PropTypes.node,
});

export default Relay.createContainer(SportPage, {
  fragments: {
    viewer: () => Relay.QL`fragment on Viewer {
      id
      supportedLanguages

      ${EditSport.getFragment('viewer')}
      ${AddSport.getFragment('viewer')}
    }`,
  }
});



// WEBPACK FOOTER //
// ./src/pages/Sport/SportPage.js